var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup625(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 50,
    viewBox: "0 0 110 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "21.302%",
    y1: "63.746%",
    x2: "92.822%",
    y2: "46.436%",
    id: "ziac2fj6ua"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0340",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#074F72",
    offset: "20%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#038898",
    offset: "32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01ACAF",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9B8",
    offset: "45%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA7B3",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C79A5",
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79659F",
    offset: "85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B63793",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "77.755%",
    y1: "7.998%",
    x2: "26.409%",
    y2: "136.487%",
    id: "6s9ot7rimb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0340",
    offset: "16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#074F72",
    offset: "27%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#038898",
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01ACAF",
    offset: "42%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9B8",
    offset: "45%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA6B3",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D76A5",
    offset: "75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B63793",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.744%",
    y1: "63.711%",
    x2: "98.384%",
    y2: "39.903%",
    id: "rsqtfac1hc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0340",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#074F72",
    offset: "16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#038898",
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01ACAF",
    offset: "40%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9B8",
    offset: "45%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3792AD",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6471A4",
    offset: "64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88589C",
    offset: "73%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A14697",
    offset: "81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13B94",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B63793",
    offset: "95%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.131 9.717a45.727 45.727 0 0 0-3.91 3.863 25.377 25.377 0 0 1-3.239 3.307 3.768 3.768 0 0 1-2.141.759 3.002 3.002 0 0 1-3.117-3.057 3.212 3.212 0 0 1 5.021-2.655c.534.363.947.877 1.186 1.476 0 .075.054.15.074.224l.15-.136 3.164-2.9v-2.52h-3.388v.731a6.458 6.458 0 0 0-2.995-.732 6.465 6.465 0 1 0 2.556 12.4 6.41 6.41 0 0 0 2.133-1.503c1.05-1.125 2.141-2.216 3.212-3.32.793-.814 1.586-1.634 2.385-2.447.902-.928 1.803-1.918 3.205-1.918a3.219 3.219 0 0 1 3.22 3.212 3.219 3.219 0 0 1-6.377.624l-2.514 2.527a6.471 6.471 0 0 0 5.685 3.389 6.465 6.465 0 0 0 6.465-6.465 6.466 6.466 0 0 0-6.479-6.499 6.593 6.593 0 0 0-4.296 1.64z",
    fill: "url(#ziac2fj6ua)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.312 10.571V8.104h-3.388l.082 5.51 3.306-3.043z",
    fill: "#555555",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.222 13.275c.902-.929 1.803-1.918 3.206-1.918a3.219 3.219 0 0 1 3.218 3.212 3.219 3.219 0 0 1-3.218 3.219 3.226 3.226 0 0 1-3.158-2.663l-2.514 2.527a6.471 6.471 0 0 0 5.685 3.389 6.465 6.465 0 0 0 6.465-6.465 6.466 6.466 0 0 0-6.478-6.499 6.593 6.593 0 0 0-4.297 1.64",
    fill: "url(#6s9ot7rimb)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.412 22.844a3.964 3.964 0 0 1-1.927.67 2.9 2.9 0 0 1-2.785-1.979h-3.693c.384 2.394 1.585 4.023 3.605 4.886 3.029 1.294 5.502.23 7.332-1.315 1.63-1.355 2.29-3.503 1.978-6.444l-3.171 2.643a3.964 3.964 0 0 1-1.339 1.54z",
    fill: "#555555",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.982 16.887a25.377 25.377 0 0 0 3.24-3.26 45.727 45.727 0 0 1 3.91-3.862 6.593 6.593 0 0 1 4.295-1.688 6.465 6.465 0 0 1 6.465 6.465c-2.71-2.173-4.865-3.244-6.465-3.212-1.402 0-2.303.99-3.205 1.918-.8.813-1.592 1.633-2.385 2.446-1.07 1.105-2.162 2.196-3.212 3.32a6.41 6.41 0 0 1-4.69 2.033 6.465 6.465 0 0 1-6.464-6.464s3.924 3.035 6.37 3.042a3.768 3.768 0 0 0 2.141-.738z",
    fill: "url(#rsqtfac1hc)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71 8.938a6.472 6.472 0 0 0-3.218-.86A6.466 6.466 0 0 0 0 14.568a6.465 6.465 0 0 0 6.465 6.465 6.465 6.465 0 0 0 3.218-.854v.854h3.53V8.077H9.712v.861zm-5.494 7.88a3.219 3.219 0 0 1-.943-2.276 3.219 3.219 0 0 1 6.438 0 3.219 3.219 0 0 1-3.22 3.246v-.027c-.853 0-1.672-.34-2.275-.943zM78.524 8.938a6.471 6.471 0 0 0-3.219-.86 6.465 6.465 0 1 0 3.219 12.075v.854h3.53V8.077h-3.53v.861zm-5.49 7.878a3.219 3.219 0 0 1 0-4.545 3.212 3.212 0 0 1 2.271-.941 3.212 3.212 0 0 1 3.219 3.212 3.219 3.219 0 0 1-3.219 3.246v-.027a3.219 3.219 0 0 1-2.272-.945z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.246 10.31a4.513 4.513 0 0 0-1.265-1.596 4.418 4.418 0 0 0-3.639-.454 5.326 5.326 0 0 0-1.708.773 5.11 5.11 0 0 0-1.226 1.226 3.91 3.91 0 0 0-1.247-1.545 4.405 4.405 0 0 0-3.666-.454 5.36 5.36 0 0 0-1.714.773 4.703 4.703 0 0 0-.786.617V8.077h-3.538v12.957h3.538v-8.132c.345-.738 1.118-1.918 2.453-1.85 1.938.102 1.938 2.589 1.938 3.978v5.983h3.476v-8.145c.366-.745 1.125-1.863 2.426-1.795 1.938.101 1.938 2.588 1.938 3.977v5.984h3.483v-3.95c-.027-1.593 0-3.193-.027-4.785a4.513 4.513 0 0 0-.436-1.99z",
    fill: "#555555",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.906 0v21.034h-3.53V0h3.53z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.518 22.845a3.944 3.944 0 0 1-1.926.669 2.914 2.914 0 0 1-2.791-1.979h-3.68c.38 2.394 1.581 4.023 3.605 4.886 3.036 1.294 5.496.23 7.332-1.315 1.626-1.355 2.284-3.503 1.972-6.444l-3.178 2.643a3.944 3.944 0 0 1-1.334 1.54zM101.461 17.033a3.212 3.212 0 0 1-1.097-1.908l-2.514 2.527a6.458 6.458 0 0 0 5.679 3.388 6.404 6.404 0 0 0 2.182-.393l-2.033-2.866-.15.007a3.212 3.212 0 0 1-2.067-.755z",
    fill: "#555555",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.503 12.073a6.465 6.465 0 0 0-5.974-3.996 6.607 6.607 0 0 0-4.297 1.64 46.757 46.757 0 0 0-3.91 3.863 24.53 24.53 0 0 1-3.239 3.307 3.768 3.768 0 0 1-2.134.759 3.009 3.009 0 0 1-3.124-3.057 3.219 3.219 0 0 1 5.025-2.654c.533.362.945.876 1.182 1.475l.081.224.143-.136 3.164-2.9v-2.52h-3.388v.731a6.465 6.465 0 1 0-2.988 12.197 6.43 6.43 0 0 0 4.689-2.032c1.05-1.125 2.141-2.216 3.219-3.32l2.378-2.447c.908-.928 1.803-1.918 3.205-1.918a3.219 3.219 0 0 1 2.921 1.864h-3.232v2.71H110v-1.355l-.007.04c.001-.849-.165-1.69-.49-2.475z",
    fill: "#555555",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup625);
export default __webpack_public_path__ + "static/media/group-625.e1e3641e71abb4a7a5d73336234b6172.svg";
export { ForwardRef as ReactComponent };